import { Stack } from 'expo-router';

export default function HomeLayout() {
  return (
    <Stack>
      <Stack.Screen
        name="(topTabs)"
        options={{
          headerShown: false
        }}
      />
    </Stack>
  );
}
